/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MarkupV2Delete,
    MarkupV2DeleteFromJSON,
    MarkupV2DeleteToJSON,
    MarkupV2ListConfiguration,
    MarkupV2ListConfigurationFromJSON,
    MarkupV2ListConfigurationToJSON,
    MarkupV2ListItemPaginationWrapper,
    MarkupV2ListItemPaginationWrapperFromJSON,
    MarkupV2ListItemPaginationWrapperToJSON,
    MarkupV2Query,
    MarkupV2QueryFromJSON,
    MarkupV2QueryToJSON,
    MarkupV2State,
    MarkupV2StateFromJSON,
    MarkupV2StateToJSON,
    MarkupV2StateResponse,
    MarkupV2StateResponseFromJSON,
    MarkupV2StateResponseToJSON,
} from '../models';

export interface ApiMarkupV2MarkupV2ListDeleteMarkupsBulkDeleteRequest {
    markupV2Delete: Array<MarkupV2Delete>;
}

export interface ApiMarkupV2MarkupV2ListExportPostRequest {
    markupV2Query?: MarkupV2Query;
}

export interface ApiMarkupV2MarkupV2ListListPostRequest {
    markupV2Query?: MarkupV2Query;
}

export interface ApiMarkupV2MarkupV2ListUpdateStateBulkPostRequest {
    markupV2State: Array<MarkupV2State>;
}

/**
 * no description
 */
export class MarkupV2ListApi extends runtime.BaseAPI {

    /**
     */
    async apiMarkupV2MarkupV2ListDeleteMarkupsBulkDeleteRaw(requestParameters: ApiMarkupV2MarkupV2ListDeleteMarkupsBulkDeleteRequest): Promise<runtime.ApiResponse<Array<MarkupV2StateResponse>>> {
        if (requestParameters.markupV2Delete === null || requestParameters.markupV2Delete === undefined) {
            throw new runtime.RequiredError('markupV2Delete','Required parameter requestParameters.markupV2Delete was null or undefined when calling apiMarkupV2MarkupV2ListDeleteMarkupsBulkDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupV2/MarkupV2List/DeleteMarkupsBulk`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.markupV2Delete.map(MarkupV2DeleteToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MarkupV2StateResponseFromJSON));
    }

    /**
     */
    async apiMarkupV2MarkupV2ListDeleteMarkupsBulkDelete(requestParameters: ApiMarkupV2MarkupV2ListDeleteMarkupsBulkDeleteRequest): Promise<Array<MarkupV2StateResponse>> {
        const response = await this.apiMarkupV2MarkupV2ListDeleteMarkupsBulkDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiMarkupV2MarkupV2ListExportPostRaw(requestParameters: ApiMarkupV2MarkupV2ListExportPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupV2/MarkupV2List/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkupV2QueryToJSON(requestParameters.markupV2Query),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiMarkupV2MarkupV2ListExportPost(requestParameters: ApiMarkupV2MarkupV2ListExportPostRequest): Promise<string> {
        const response = await this.apiMarkupV2MarkupV2ListExportPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiMarkupV2MarkupV2ListGetListConfigurationGetRaw(): Promise<runtime.ApiResponse<MarkupV2ListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupV2/MarkupV2List/GetListConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkupV2ListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiMarkupV2MarkupV2ListGetListConfigurationGet(): Promise<MarkupV2ListConfiguration> {
        const response = await this.apiMarkupV2MarkupV2ListGetListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiMarkupV2MarkupV2ListListPostRaw(requestParameters: ApiMarkupV2MarkupV2ListListPostRequest): Promise<runtime.ApiResponse<MarkupV2ListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupV2/MarkupV2List/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkupV2QueryToJSON(requestParameters.markupV2Query),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkupV2ListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiMarkupV2MarkupV2ListListPost(requestParameters: ApiMarkupV2MarkupV2ListListPostRequest): Promise<MarkupV2ListItemPaginationWrapper> {
        const response = await this.apiMarkupV2MarkupV2ListListPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiMarkupV2MarkupV2ListUpdateStateBulkPostRaw(requestParameters: ApiMarkupV2MarkupV2ListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<MarkupV2StateResponse>>> {
        if (requestParameters.markupV2State === null || requestParameters.markupV2State === undefined) {
            throw new runtime.RequiredError('markupV2State','Required parameter requestParameters.markupV2State was null or undefined when calling apiMarkupV2MarkupV2ListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupV2/MarkupV2List/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.markupV2State.map(MarkupV2StateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MarkupV2StateResponseFromJSON));
    }

    /**
     */
    async apiMarkupV2MarkupV2ListUpdateStateBulkPost(requestParameters: ApiMarkupV2MarkupV2ListUpdateStateBulkPostRequest): Promise<Array<MarkupV2StateResponse>> {
        const response = await this.apiMarkupV2MarkupV2ListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
